import { Box, Container, Typography, Grid, Paper } from 'src/components';
import { useIsMobile } from 'src/hooks';

import offlineImg from 'src/assets/videos/features/map-features-desktop.png';
import emergencyImg from 'src/assets/videos/features/handbook-desktop.png';
import meetupImg from 'src/assets/videos/features/user-details-modal.png';

const miniFeatures = [
  {
    title: 'Offline Maps',
    description: "See all your saved pins and nearby attractions even when you're off the grid.",
    image: offlineImg,
  },
  {
    title: 'PanAm Handbook',
    description: 'Everything you need to conquer the Pan-American Highway in one place!',
    image: emergencyImg,
  },
  {
    title: 'Find Travel Buddies',
    description: 'See who’s nearby and connect with other overlanders on the road.',
    image: meetupImg,
  },
];

const MiniFeaturesSection = () => {
  const isMobile = useIsMobile();

  return (
    <Box sx={{ bgcolor: 'background.main', py: 6 }}>
      <Container>
        <Box sx={{ textAlign: 'center', mb: isMobile ? 3 : 6 }}>
          <Typography
            variant={isMobile ? "h3" : "h2"}
            sx={{ fontWeight: 700, mb: 2 }}
          >
            More to Make Your Trip Smooth
          </Typography>
          <Typography
            variant="h5"
            sx={{
              color: '#666',
              fontWeight: 400,
              maxWidth: 600,
              mx: 'auto',
              mb: 3,
            }}
          >
            Because great adventures shouldn't be complicated.
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {miniFeatures.map((feature, index) => (
            <Grid key={index} size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                sx={{
                  p: 2,
                  borderRadius: 3,
                  textAlign: 'center',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Box
                  component="img"
                  src={feature.image}
                  alt={feature.title}
                  sx={{
                    width: '100%',
                    height: 160,
                    objectFit: 'cover',
                    borderRadius: 2,
                    mb: 2,
                  }}
                />
                <Typography variant="h5" gutterBottom fontWeight={600}>
                  {feature.title}
                </Typography>
                <Typography 
                  variant="h5"
                  sx={{
                    color: '#888',
                    fontWeight: 400,
                    maxWidth: 600,
                    mx: 'auto',
                  }}>
                  {feature.description}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default MiniFeaturesSection;
